<template>
	<div class="report">
		<header class="header">
			<div class="first-header">{{ mainTitle }}</div>
			<div class="second-header">{{ secondTitle }}</div>
			<div class="view" v-show="downloadFlag">
				<div class="download-view" @click="downloadPDF" v-show="downloadFlag">{{ btnName }}</div>
				<div class="over-view" @click="preview" v-show="previewState">预览</div>
			</div>
		</header>
		<div class="content">
			<slot></slot>
		</div>
		<footer class="footer">完</footer>
	</div>
</template>

<script>
export default {
	name: 'report-header',
	props: {
		mainTitle: {
			type: String,
			default: '命题质量分析报告'
		},
		secondTitle: {
			type: String,
			default: '命题质量分析报告'
		},
		btnName: {
			type: String,
			default: '预览'
		},
		previewState: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			downloadFlag: true
		}
	},
	methods: {
		downloadPDF() {
			this.downloadFlag = false
			this.$emit('downloadPDF')
		},
		preview() {
			this.$emit('preview')
		}
	}
}
</script>

<style scoped lang="less">
.report {
	width: 1100px;
	margin: 3px auto 10px;
	border-radius: 5px;
	overflow: hidden;
	background: white;
	box-shadow: 0 0 5px #c3c2c2;
	.header {
		background: #009688;
		color: white;
		text-align: center;

		position: relative;
		.first-header {
			font-size: 28px;
			padding-top: 35px;
		}
		.second-header {
			font-size: 20px;
			padding-top: 5px;
			padding-bottom: 35px;
		}
		.view {
			position: absolute;
			right: 10px;
			top: 50%;
			transform: translateY(-50%);
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}
		.download-view {
			padding: 8px 30px;
			background: white;
			color: #009688;
			border-radius: 25px;
			&:hover {
				cursor: pointer;
			}
		}
		.over-view {
			padding: 8px 30px;
			background: white;
			color: #009688;
			border-radius: 25px;
			margin-left: 15px;
			&:hover {
				cursor: pointer;
			}
		}
		@media print {
			.first-header {
				font-size: 36px;
			}
			.second-header {
				font-size: 28px;
			}
		}
	}
	.content {
		padding: 0 10px;
		box-sizing: border-box;
	}
	.footer {
		height: 150px;
		background: #009688;
		text-align: center;
		line-height: 150px;
		color: white;
		font-size: 35px;
	}
}
</style>
